import Base from './Base';

class Participants extends Base {
    enterPincode(data, opts = null) {
        return this.postJSONWithSession(this.urlGenerator('pincode'), data, opts);
    }
}

export default Participants;
